const aggregateItem = require('./aggregateItem.vue');
const colorbox = require('./colorbox.vue');

const Dictionary = require('./dictionary');
const directives = require('./directives');

module.exports = {
    aggregateItem,
    colorbox,

    Dictionary,
    directives,
};



// WEBPACK FOOTER //
// ./src/components/vue-ctrls/ctrls.js